import * as React from "react"
import styled from "@digits-css"
import type { GradientProps } from "@digits-shared/DesignSystem/Containers/AIGradientDefs"
import stringHelper from "@digits-shared/helpers/stringHelper"
import useConstant from "@digits-shared/hooks/useConstant"
import { v4 as generateUUID } from "uuid"
import "./SvgAIGradient.digits.css"

const SVGContainer = styled.svg({ cls: "SvgAIGradient__SVGContainer_78b88c1", vars: { "--SvgAIGradient__SVGContainer_78b88c1-p0": ({ uuid }) => `url(#${uuid})`, "--SvgAIGradient__SVGContainer_78b88c1-p1": ({ uuid }) => `url(#${uuid})` } })

export const SvgAIFillGradient: React.FC<{
  className?: string
  pathIcon?: boolean
  IconComponent: React.ComponentType<React.SVGProps<SVGSVGElement>>
}> = ({ className, IconComponent, pathIcon }) => {
  const gradientId = useConstant(() => `svg_gradient_${generateUUID()}`)

  return (
    <SVGContainer
      uuid={gradientId}
      className={stringHelper.classNames(className, pathIcon ? "path-icon" : "fill-icon")}
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient
          id={gradientId}
          x1="2.51869"
          y1="24.3981"
          x2="20.3187"
          y2="22.6469"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#399CD4" />
          <stop offset="1" stopColor="#5E5BE9" />
        </linearGradient>
      </defs>
      <IconComponent />
    </SVGContainer>
  )
}
